import {SidePanel} from '@github-ui/side-panel'
import {testIdProps} from '@github-ui/test-id-props'
import {useRef} from 'react'

import {
  FocusTrapManagementContextProvider,
  useFocusTrapManagementContext,
} from '../../contexts/FocusTrapManagementProvider'
import {useSiteHeaderHeight} from '../../hooks/use-site-header-height'
import styles from './IssueSidePanel.module.css'

type IssueSidePanelProps = {
  onClose: () => void
  children: React.ReactNode
}

const IssueSidePanelInternal = ({onClose, children}: IssueSidePanelProps) => {
  const sidePanelReturnFocusRef = useRef(null)
  const sidePanelInitialFocusRef = useRef<HTMLDivElement>(null)
  const siteHeaderSize = useSiteHeaderHeight()
  const {disableFocusTrap} = useFocusTrapManagementContext()

  return (
    <SidePanel
      open
      defaultCloseElement="overlay"
      onClose={onClose}
      initialFocusRef={sidePanelInitialFocusRef}
      returnFocusRef={sidePanelReturnFocusRef}
      aria-labelledby="issue-side-panel"
      width="min(90%, 1280px)"
      topOffset={siteHeaderSize}
      externalFocusTrapDisabled={disableFocusTrap}
    >
      <div id="issue-viewer-side-panel" className={styles.IssueSidePanelContent}>
        <span tabIndex={-1} ref={sidePanelInitialFocusRef} {...testIdProps('side-panel-focus-target')} />
        {children}
      </div>
    </SidePanel>
  )
}

export const IssueSidePanel = ({onClose, children}: IssueSidePanelProps) => {
  return (
    <FocusTrapManagementContextProvider>
      <IssueSidePanelInternal onClose={onClose}>{children}</IssueSidePanelInternal>
    </FocusTrapManagementContextProvider>
  )
}

try{ IssueSidePanelInternal.displayName ||= 'IssueSidePanelInternal' } catch {}
try{ IssueSidePanel.displayName ||= 'IssueSidePanel' } catch {}